(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setPointerModality = () => root.classList.add('dl-using-pointer');
  const setKeyboardModality = (event) => {
    if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ') {
      root.classList.remove('dl-using-pointer');
    }
  };

  window.addEventListener('pointerdown', setPointerModality, { passive: true });
  window.addEventListener('keydown', setKeyboardModality);

  const initReveals = (scope = document) => {
    const targets = [...scope.querySelectorAll('[data-dl-reveal], [data-dl-stagger]')]
      .filter((target) => target.dataset.dlRevealReady !== 'true');
    if (!targets.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach((target) => {
        target.dataset.dlRevealReady = 'true';
        target.classList.add('is-visible');
      });
      return;
    }

    root.classList.add('dl-motion-ready');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    targets.forEach((target) => {
      target.dataset.dlRevealReady = 'true';
      const bounds = target.getBoundingClientRect();
      const isInViewport = bounds.top < window.innerHeight && bounds.bottom > 0;
      if (isInViewport) {
        target.classList.add('is-visible');
      } else {
        observer.observe(target);
      }
    });
  };

  const showAllMotionContent = () => {
    if (!reduceMotion.matches) return;
    document.querySelectorAll('[data-dl-reveal], [data-dl-stagger]').forEach((target) => target.classList.add('is-visible'));
  };

  const initMobileNavigation = (scope = document) => {
    const menus = scope.querySelectorAll('.dl-mobile-nav');
    menus.forEach((menu) => {
      if (menu.dataset.dlReady === 'true') return;
      menu.dataset.dlReady = 'true';
      const summary = menu.querySelector('summary');

      const syncOpenState = () => {
        summary?.setAttribute('aria-expanded', String(menu.open));
        root.classList.toggle('dl-nav-open', menu.open);
      };

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          menu.removeAttribute('open');
          syncOpenState();
        });
      });

      menu.addEventListener('toggle', syncOpenState);

      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        menu.removeAttribute('open');
        syncOpenState();
        summary?.focus();
      });
    });
  };

  const initTickers = (scope = document) => {
    scope.querySelectorAll('.dl-signal--moving').forEach((ticker) => {
      if (ticker.dataset.dlTickerReady === 'true') return;
      const button = ticker.querySelector('[data-dl-ticker-toggle]');
      const label = button?.querySelector('[data-dl-ticker-toggle-label]');
      if (!button || !label) return;

      ticker.dataset.dlTickerReady = 'true';
      ticker.classList.add('is-ready');

      button.addEventListener('click', () => {
        const isPaused = ticker.classList.toggle('is-paused');
        const nextLabel = isPaused ? button.dataset.playLabel : button.dataset.pauseLabel;
        button.setAttribute('aria-label', nextLabel);
        label.textContent = nextLabel;
      });
    });
  };

  const init = (scope = document) => {
    initReveals(scope);
    initMobileNavigation(scope);
    initTickers(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  reduceMotion.addEventListener?.('change', showAllMotionContent);
})();
